// RiskHeatMatrixDialog.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
} from "@mui/material";

const HeatMatrixDialog = ({ open, onClose }) => {
  const rows = [
    {
      severity: "Critical",
      bg: "#F44336", // red
      action:
        "Unacceptable. Immediate action required to develop and initiate mitigation plans.",
      range: "15 to 25",
    },
    {
      severity: "Moderate",
      bg: "#FFC107", // amber
      action:
        "Tolerable. Functional head attention required to develop strict control measures.",
      range: "6 to 14",
    },
    {
      severity: "Low",
      bg: "#9CCC65", // green
      action:
        "Low risk, acceptable. Manage by routine procedures.",
      range: "1 to 5",
    },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontFamily: "Outfit", fontWeight: 600 }}>
        Risk Tolerance – Heat Matrix
      </DialogTitle>

      <DialogContent dividers>
        <Typography
          sx={{
            mb: 2,
            fontSize: "14px",
            fontFamily: "Outfit",
            color: "#4B5563",
          }}
        >
          This table explains how <strong>Severity Level</strong> relates to{" "}
          <strong>Risk Rating</strong> (Impact × Likelihood) and what{" "}
          <strong>actions</strong> are expected for each band.
        </Typography>

        <Box sx={{ overflowX: "auto" }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "160px 1fr 170px",
              border: "1px solid #000000",
              borderRadius: "4px",
              overflow: "hidden",
              minWidth: "700px",
            }}
          >
            {/* Header row */}
            <Box
              sx={{
                borderRight: "1px solid #000000",
                borderBottom: "1px solid #000000",
                p: 1.2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#FFFFFF",
              }}
            >
              <Typography
                sx={{ fontWeight: 700, fontSize: "13px", textAlign: "center" }}
              >
                Severity Level
              </Typography>
            </Box>

            <Box
              sx={{
                borderRight: "1px solid #000000",
                borderBottom: "1px solid #000000",
                p: 1.2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#FFFFFF",
              }}
            >
              <Typography
                sx={{ fontWeight: 700, fontSize: "13px", textAlign: "center" }}
              >
                Action
              </Typography>
            </Box>

            <Box
              sx={{
                borderBottom: "1px solid #000000",
                p: 1.2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#FFFFFF",
              }}
            >
              <Typography
                sx={{ fontWeight: 700, fontSize: "13px", textAlign: "center" }}
              >
                Risk Rating
                <br />
                (Impact × Likelihood)
              </Typography>
            </Box>

            {/* Data rows */}
            {rows.map((row, idx) => (
              <React.Fragment key={row.severity}>
                {/* Severity cell */}
                <Box
                  sx={{
                    borderRight: "1px solid #000000",
                    borderBottom:
                      idx === rows.length - 1
                        ? "1px solid #000000"
                        : "1px solid #000000",
                    p: 1.5,
                    bgcolor: row.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "14px",
                      textAlign: "center",
                      color: "#000000",
                    }}
                  >
                    {row.severity}
                  </Typography>
                </Box>

                {/* Action cell */}
                <Box
                  sx={{
                    borderRight: "1px solid #000000",
                    borderBottom:
                      idx === rows.length - 1
                        ? "1px solid #000000"
                        : "1px solid #000000",
                    p: 1.5,
                    bgcolor: "#FFFFFF",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ fontSize: "13px", color: "#111827" }}>
                    {row.action}
                  </Typography>
                </Box>

                {/* Risk rating cell */}
                <Box
                  sx={{
                    borderBottom:
                      idx === rows.length - 1
                        ? "1px solid #000000"
                        : "1px solid #000000",
                    p: 1.5,
                    bgcolor: row.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "14px",
                      textAlign: "center",
                      color: "#000000",
                    }}
                  >
                    {row.range}
                  </Typography>
                </Box>
              </React.Fragment>
            ))}
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          sx={{ textTransform: "none", fontFamily: "Outfit" }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HeatMatrixDialog;
